@if (currentContentPage$ | async; as currentContentPage) {
<ish-skip-content-link skipToElementId="nav-breadcrumbs" linkText="common.skip_content.link.text.navigation" />
<ul>
  <ng-container
    [ngTemplateOutlet]="pageTreeNode"
    [ngTemplateOutletContext]="{ treeNodes: [contentPageTree()], counter: 1 }"
  />
</ul>
<!-- the recursively used template to render the tree nodes -->
<ng-template #pageTreeNode let-treeNodes="treeNodes" let-counter="counter">
  @for (treeNode of treeNodes; track treeNode) {
  <li [ngClass]="{ 'page-navigation-active': treeNode.contentPageId === currentContentPage.id }">
    <a [routerLink]="treeNode | ishContentPageRoute" [title]="treeNode.name" class="link-decoration-hover">{{
      treeNode.name
    }}</a>
    @if (treeNode.children.length && depth() > counter) {
    <ul [ngClass]="'page-navigation-' + counter">
      <ng-container
        [ngTemplateOutlet]="pageTreeNode"
        [ngTemplateOutletContext]="{ treeNodes: treeNode.children, counter: counter + 1 }"
      />
    </ul>
    }
  </li>
  }
</ng-template>
}
